export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7086.1dd28d0f.jpg";